import * as React from 'react';
import WarningModal from './WarningModal';
import AdditionalQuestionForm from './AdditionalQuestionForm';

import './AdditionalQuestionModal.scss';
import { FieldType } from './types';

type Props = {
  orgId: number;
  show: boolean;
  formId: number;
  onClose?: () => any;
  onSave?: (field: FieldType) => void;
  addQuestionToRow: number;
};

const AdditionalQuestionModal = ({ orgId, show, onClose, onSave, formId, addQuestionToRow }: Props) => {
  const [showWarning, setShowWarning] = React.useState(false);

  return (
    <>
      {show && (
        <div id="additional-question-modal">
          <div className="additional-question-modal__content">
            <h3 data-testid="create-question-heading">Create Question</h3>
            <AdditionalQuestionForm
              orgId={orgId}
              formId={formId}
              onCancel={onClose}
              onSave={(addedQuestion) => onSave(addedQuestion)}
              addQuestionToRow={addQuestionToRow}
            />
          </div>
        </div>
      )}
      <WarningModal
        show={showWarning}
        onClose={() => setShowWarning(false)}
        onSubmit={() => {
          setShowWarning(false);
          onClose();
        }}
      >
        <p className="u-padEndsSm">All unsaved changes will be lost.</p>
      </WarningModal>
    </>
  );
};

export default AdditionalQuestionModal;
